<template>
  <v-autocomplete
    v-model="innerValue"
    :items="items"
    item-value="id"
    item-text="mrc_des"
    return-object
    v-bind="$attrs"
    v-on="$listeners"
    :loading="isLoading"
    :search-input.sync="search"
  >
  </v-autocomplete>
</template>

<script>
import cloneDeep from 'lodash.clonedeep'

import { searchGoodsMap } from '@/services/search-api.service'

export default {
  name: 'SearchGoodsMapField',
  components: {},
  props: {
    value: {
      type: null,
    },
  },
  data: () => ({
    innerValue: '',
    entries: [],
    isLoading: false,
    search: null,
  }),
  computed: {
    items() {
      return this.entries
    },
  },
  watch: {
    // Handles internal model changes.
    innerValue(newVal) {
      this.$emit('input', newVal)
    },
    // Handles external model changes.
    value(newVal) {
      this.innerValue = newVal
      this.entries = [this.value]
    },

    search(val) {
      if (!val) return
      if (val.length === 0) return
      if (this.isLoading) return

      this.isLoading = true

      // Lazily load input items
      searchGoodsMap(val)
        .then(({ data }) => {
          this.entries = data
        })
        .catch((err) => {
          console.error(err)
        })
        .finally(() => (this.isLoading = false))
    },
  },
  created() {
    if (this.value) {
      this.search = this.value.mrc_des
      this.innerValue = cloneDeep(this.value)
      this.entries = this.innerValue ? [this.innerValue] : []
    }
  },
}
</script>

<style lang="scss" scoped></style>
